import { cn } from '@/lib/utils'
import Image from 'next/image'
import { CSSProperties, forwardRef } from 'react'

interface BackgroundImageProps {
  className?: string
  classNameImg?: string
  style?: CSSProperties
  src?: string
  imageName?: string
}

const BackgroundImage = forwardRef<HTMLDivElement, BackgroundImageProps>(
  ({ className, classNameImg, style, src, imageName = '', ...props }, ref) => {
    return (
      <>
        {src && (
          <div
            ref={ref}
            className={cn('absolute inset-0 -z-[1] max-h-lvh', className)}
            {...props}
            style={style}
          >
            <Image
              priority
              src={src}
              fill
              alt={imageName}
              className={cn('h-full w-full object-cover', classNameImg)}
            />
          </div>
        )}
      </>
    )
  },
)
BackgroundImage.displayName = 'BackgroundImage'

export default BackgroundImage
